import type { PresetDefinition } from "../lib/types";

/**
 * VisualEffect 预设：画面视觉特效
 *
 * 每种预设定义画面叠加层的参数：
 *   - grainIntensity:      颗粒/噪声强度 (0~1)
 *   - flickerSpeed:        频闪速度 (每秒闪烁次数)
 *   - flickerDepth:        频闪深度 (0~1, 1=全黑)
 *   - hueRotate:           色相旋转角度 (deg)
 *   - saturate:            饱和度倍率
 *   - contrast:            对比度倍率
 *   - brightness:          亮度倍率
 *   - scanlineOpacity:     扫描线透明度 (0~1)
 *   - vignetteStrength:    暗角强度 (0~1)
 *   - colorOverlay:        颜色叠加 { r, g, b, opacity }
 *   - rgbSplit:            RGB 分裂偏移 (px)
 */
export const presets: Record<string, PresetDefinition> = {
  // ── 📺 录像带恐怖（VHS horror）— 低频版 ──
  vhsHorror: {
    entrance: "vhsHorror",
    theme: "#ffffff",
    backgroundColor: "#0a0a0a",
    grainIntensity: 0.12,
    flickerSpeed: 0.8,
    flickerDepth: 0.08,
    hueRotate: 20,
    saturate: 1.2,
    contrast: 1.15,
    brightness: 0.9,
    scanlineOpacity: 0.08,
    vignetteStrength: 0.35,
    colorOverlay: { r: 0.6, g: 0.2, b: 0.8, opacity: 0.05 },
    rgbSplit: 1,
  },

  // ── 📡 静态噪声（static noise） ──
  staticNoise: {
    entrance: "staticNoise",
    theme: "#ffffff",
    backgroundColor: "#0a0a0a",
    grainIntensity: 0.2,
    flickerSpeed: 0,
    flickerDepth: 0,
    hueRotate: 0,
    saturate: 0.6,
    contrast: 1.3,
    brightness: 0.9,
    scanlineOpacity: 0.2,
    vignetteStrength: 0.4,
    colorOverlay: null,
    rgbSplit: 0,
  },

  // ── ⚡ 频闪 — 慢速版 ──
  flicker: {
    entrance: "flicker",
    theme: "#ffffff",
    backgroundColor: "#0a0a0a",
    grainIntensity: 0.1,
    flickerSpeed: 1.5,
    flickerDepth: 0.2,
    hueRotate: 0,
    saturate: 1.3,
    contrast: 1.4,
    brightness: 0.85,
    scanlineOpacity: 0,
    vignetteStrength: 0.4,
    colorOverlay: null,
    rgbSplit: 0,
  },

  // ── 🩸 噩梦红（nightmare）— 缓版 ──
  nightmare: {
    entrance: "nightmare",
    theme: "#ffffff",
    backgroundColor: "#0a0a0a",
    grainIntensity: 0.15,
    flickerSpeed: 0.8,
    flickerDepth: 0.1,
    hueRotate: -10,
    saturate: 1.1,
    contrast: 1.2,
    brightness: 0.85,
    scanlineOpacity: 0.08,
    vignetteStrength: 0.45,
    colorOverlay: { r: 0.8, g: 0.1, b: 0.1, opacity: 0.06 },
    rgbSplit: 0.8,
  },

  // ── 🕯️ 褪色回忆（faded） ──
  faded: {
    entrance: "faded",
    theme: "#ffffff",
    backgroundColor: "#0a0a0a",
    grainIntensity: 0.25,
    flickerSpeed: 0,
    flickerDepth: 0,
    hueRotate: 25,
    saturate: 0.3,
    contrast: 0.85,
    brightness: 1.3,
    scanlineOpacity: 0.08,
    vignetteStrength: 0.3,
    colorOverlay: { r: 0.9, g: 0.7, b: 0.4, opacity: 0.06 },
    rgbSplit: 0,
  },
};
;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
